angular.module('signalview.metricsEventsSidebar', [
    'signalview.metricsSidebar',
    'signalview.eventsPanel',
]);
